import React from 'react';
import { Skeleton, SkeletonRound, SkeletonSquare } from '@fiverr-private/feedback';
import { Box, theme } from '@fiverr-private/theme';
import { Stack } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { cardStyle } from '../JobTbdCard/JobTbdCard.ve.css';
import { jobImageSize } from '../JobTbdPage/JobTbdPage.ve.css';
import { JobTbdCardProps } from '../JobTbdCard/JobTbdCard.types';
import { getCardStaticStyles } from '../JobTbdCard/JobTbdCard.utils';
import { cardSubtitleStyle, cardTitleStyle, skeletonOpacity } from './JobCardSkeleton.ve.css';

export const JobTbdCardSkeleton = ({ jobMaxWidth }: Pick<JobTbdCardProps, 'jobMaxWidth'>) => {
    const { isMobile } = getContext();

    return (
        <Skeleton dataTestId="job-tbd-card-skeleton" width="auto">
            <Box
                height={{ default: '106px', sm: '112px' }}
                boxSizing="borderBox"
                boxShadow="z1"
                borderColor="white"
                borderStyle="solid"
                borderWidth="sm"
                borderRadius="xl"
                className={cardStyle}
                backgroundColor="white"
                {...getCardStaticStyles(isMobile ? '100%' : `${jobMaxWidth}px`)}
                marginBottom="3"
            >
                <Stack className={skeletonOpacity} direction="column" width="100%" gap="3">
                    <SkeletonSquare width="30%" height={theme.bodyLineHeights.b_xs} />
                    <Box display="flex">
                        <Box className={jobImageSize}>
                            <SkeletonRound size="100%" />
                        </Box>
                        <Box marginRight="3" />
                        <Stack direction="column" gap="0" alignItems="flexStart" width="100%">
                            <Box className={cardTitleStyle}>
                                <SkeletonSquare width="100%" height="100%" />
                            </Box>
                            <Box marginBottom="0.5" />
                            <Box className={cardSubtitleStyle}>
                                <SkeletonSquare width="100%" height="100%" />
                            </Box>
                        </Stack>
                    </Box>
                </Stack>
            </Box>
        </Skeleton>
    );
};
